import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {

  private translate = inject(TranslateService);

  ngOnInit(): void {

    const idioma_browser = navigator.language ? navigator.language : 'pt-BR';
    let defaultLanguage = 'pt';

    switch (idioma_browser) {
      case 'pt-BR':
        defaultLanguage = 'pt';
        break;
      case 'en-US':
        defaultLanguage = 'en';
        break;
      case 'es-ES':
        defaultLanguage = 'es';
        break;
      default:
        defaultLanguage = 'pt';
        break;
    }

    console.log(defaultLanguage);

    if(!localStorage.getItem('idioma')){

      localStorage.setItem('idioma', defaultLanguage);
    }

    const idiomaSalvo = localStorage.getItem('idioma') || 'pt';
    this.translate.use(idiomaSalvo);
  }

  protected title = 'extecamp';
}
